import { render, staticRenderFns } from "./supportConcept.vue?vue&type=template&id=fcd0fdcc&scoped=true&"
import script from "./supportConcept.vue?vue&type=script&lang=js&"
export * from "./supportConcept.vue?vue&type=script&lang=js&"
import style0 from "./supportConcept.vue?vue&type=style&index=0&id=fcd0fdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd0fdcc",
  null
  
)

export default component.exports